module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/05_Foreword"
    }
  }, [_vm._v("Foreword by Nigel Cave")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Bibliography"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chp1t"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_chapter01"
    }
  }, [_c('span', {
    staticClass: "tocr"
  }, [_c('i', [_vm._v("Chapter One")])]), _vm._v(" "), _c('b', [_vm._v("Battleground Italy: Salerno to Rome")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chp1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocr"
  }, [_c('i', [_vm._v("Chapter Two")])]), _vm._v(" "), _c('b', [_vm._v("Battleground Normandy: D-Day to Paris")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocr"
  }, [_c('i', [_vm._v("Chapter Three")])]), _vm._v(" "), _c('b', [_vm._v("Operation Valkyrie: Attempt to Kill Hitler")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chp2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocr"
  }, [_c('i', [_vm._v("Chapter Four")])]), _vm._v(" "), _c('b', [_vm._v("Hitler’s Revenge: The Flying Bomb and V-2")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chp3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocr"
  }, [_c('i', [_vm._v("Chapter Five")])]), _vm._v(" "), _c('b', [_vm._v("Americans Advance in the South Pacific")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chp4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocr"
  }, [_c('i', [_vm._v("Chapter Six")])]), _vm._v(" "), _c('b', [_vm._v("Japanese in Burma: Kohima and Imphal")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocr"
  }, [_c('i', [_vm._v("Chapter Seven")])]), _vm._v(" "), _c('b', [_vm._v("Hitler Loses His Army Group Centre")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocr"
  }, [_c('i', [_vm._v("Chapter Eight")])]), _vm._v(" "), _c('b', [_vm._v("Allied Bomber Offensive: Berlin, Ball Bearings and Oil")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-147245f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 72
// module chunks = 0